module.exports = __webpack_public_path__ + "static/img/2018-03-03 15.38.32.f08e07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2018-03-03 15.38.32.jpg
// module id = s7kr
// module chunks = 4